import { Controller, useFormContext } from 'react-hook-form';
import { Modal } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Input } from 'ui/input/Input';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { AddZoneProps, AddZoneFormBody } from './AddZone.types';
import * as Styled from './AddZone.styles';

export const AddZone = ({ parentZone, onSubmit, isModalOpen, onModalClose, isLoading }: AddZoneProps) => {
  const { formatMessage } = useLocale();
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useFormContext<AddZoneFormBody>();

  return (
    <Modal
      header={formatMessage({ id: AppMessages['definitions.zones.add.title'] })}
      open={isModalOpen}
      onClose={onModalClose}
      type="form"
      onSubmit={handleSubmit(onSubmit)}
      submitButtonDisabled={!isValid || isLoading}
    >
      <>
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['definitions.zones.add.parent'] })} {parentZone.kod} {parentZone.nazwa}
        </ActionModal.Subtitle>
        <Styled.Wrapper>
          <Controller
            name="kod"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['definitions.zones.add.code.label'] })}
                placeholder={formatMessage({ id: AppMessages['definitions.zones.add.code.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />

          <Controller
            name="nazwa"
            control={control}
            render={({ field, fieldState: { error } }) => (
              <Input
                {...field}
                label={formatMessage({ id: AppMessages['definitions.zones.add.name.label'] })}
                placeholder={formatMessage({ id: AppMessages['definitions.zones.add.name.placeholder'] })}
                errorMessage={error?.message}
                required
              />
            )}
          />
        </Styled.Wrapper>
      </>
    </Modal>
  );
};
